<template>
    <views class="faq-item">
        <views class="faq-q">
            <views class="title">{{ item.topic }}</views>
        </views>
        <views class="create_time">
            {{item.created_at}} {{item.contact}}

        </views>
        <views
            :class="{'all': isOpen}"
            class="faq-a">
            <views class="title">{{ item.content }}</views>
        </views>
        <views v-show="!isOpen && item.content.length > 70" class="open" @click="toggle">
            <images :src="openIcon"></images>
        </views>
        <views v-show="isOpen" class="close" @click="toggle">
            <images :src="closeIcon"></images>
        </views>
        <div class="reply-box" v-if="item.reply">
            <div class="reply-time">
                <div>回复</div>
                <div class="time">{{item.reply_time}}</div>
            </div>
            <views class="title">{{item.reply}}</views>
        </div>
    </views>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isOpen: false,
            aIcon: require('@/assets/images/a.png'),
            qIcon: require('@/assets/images/q.png'),
            openIcon: require('@/assets/images/qa_open.png'),
            closeIcon: require('@/assets/images/qa_close.png')
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
